/**
 * Biocemento Configurateur premium — composition panier catalogue.
 */
(function () {
  'use strict';

  const STORAGE_TEINTE = 'biocemento:teinte';
  const STEPS = 5; // 0 espace · 1 superficies · 2 système · 3 teinte · 4 récap
  const CONFIG_STEPS = 5;
  const TEINTE_CATEGORY_ORDER = ['clairs', 'neutres', 'chaleurs', 'profonds'];
  const AUTO_ADVANCE_MS = 340;

  const OPTION_DETAILS = {
    'finition-minerale': {
      title: 'Béton ciré minérale',
      price: 'Inclus',
      copy: 'Finition minérale seule en 2 couches. Le rendu signature Biocemento, mat et minéral, idéal pour la majorité des projets.',
      bullets: ['2 couches de finition minérale', '21 teintes disponibles', 'Rendu mat premium'],
      images: ['biocemento-homepage-09.jpg'],
    },
    'finition-coule': {
      title: 'Minérale + béton coulé',
      price: '+ 25 €/m²',
      copy: '2 couches de finition minérale puis 1 couche de béton coulé à la chaux pour un effet monolithique et profond.',
      bullets: ['2 couches minérale + 1 couche coulé', 'Effet coulé monolithique', 'Supplément calculé sur vos m²'],
      images: ['biocemento-homepage-10.jpg'],
    },
    'substrate-carrelage': {
      title: 'Support carrelage',
      price: 'Primaire carrelage inclus',
      copy: 'Sur carrelage ou support lisse non poreux, nous intégrons le primaire carrelage adapté.',
      bullets: ['Adhérence sur supports lisses', 'Compatible pièces humides', 'Inclus dans votre kit'],
      images: ['biocemento-homepage-02.png'],
    },
    'substrate-siporex': {
      title: 'Support siporex',
      price: 'Primaire universel inclus',
      copy: 'Le siporex est poreux : le primaire universel assure une accroche optimale avant vos couches Biocemento.',
      bullets: ['Support poreux', 'Primaire universel', 'Séchage contrôlé'],
      images: ['biocemento-homepage-04.png'],
    },
    'substrate-planeite': {
      title: 'Rattrapage planeité',
      price: 'Préparation renforcée conseillée',
      copy: 'Pour les supports irréguliers ou les chapes à reprendre, nous vous proposons la préparation renforcée Biocemento.',
      bullets: ['Planeité chantier', 'Option préparation +25 €/m²', 'Rendu uniforme garanti'],
      images: ['biocemento-homepage-05.png'],
    },
    'prep-renforcee': {
      title: 'Préparation renforcée Biocemento',
      price: '+ 25 €/m²',
      copy: 'Mortier de rattrapage planeité premium pour homogénéiser le support avant l\'application du béton ciré.',
      bullets: ['Rattrapage des défauts de planeité', 'Base technique irréprochable', 'Facturé au m² de votre projet'],
      images: ['biocemento-homepage-05.png', 'biocemento-homepage-09.jpg'],
    },
  };

  let autoAdvanceTimer = null;
  let teinteSearchQuery = '';
  let activeSystemDetail = 'finition-minerale';

  const state = {
    step: 0,
    space: null,
    m2Floor: 8,
    m2Wall: 4,
    waste: true,
    finition: 'minerale',
    substrate: null,
    prepRenforcee: false,
    teinte: null,
    catalog: null,
    teintes: [],
    products: {},
    hasMinerale5: false,
  };

  function $(sel, root = document) {
    return root.querySelector(sel);
  }

  function $$(sel, root = document) {
    return [...root.querySelectorAll(sel)];
  }

  function getRoot() {
    return document.querySelector('[data-bio-configurateur]');
  }

  function getConfig() {
    const el = document.getElementById('BioConfiguratorConfig');
    return el ? JSON.parse(el.textContent) : {};
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function formatM2(n) {
    return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(n);
  }

  async function loadData() {
    const config = getConfig();
    const [catalogRes, teintesRes] = await Promise.all([
      config.catalogUrl ? fetch(config.catalogUrl) : null,
      config.teintesUrl ? fetch(config.teintesUrl) : null,
    ]);

    if (catalogRes?.ok) state.catalog = await catalogRes.json();
    if (teintesRes?.ok) state.teintes = await teintesRes.json();

    const handles = new Set();
    if (state.catalog?.products) {
      Object.values(state.catalog.products).forEach((p) => {
        if (p.handle) handles.add(p.handle);
      });
    }

    const root = config.routes?.root || '/';
    await Promise.all(
      [...handles].map(async (handle) => {
        try {
          const res = await fetch(`${root}products/${handle}.js`);
          if (res.ok) state.products[handle] = await res.json();
        } catch (e) {
          /* ignore */
        }
      })
    );

    const h5 = state.catalog?.products?.minerale5?.handle;
    const pub5 = state.catalog?.storefrontPublished?.[h5];
    state.hasMinerale5 =
      pub5 === true || (pub5 !== false && Boolean(h5 && state.products[h5]?.variants?.length));
  }

  function clampM2(val) {
    return Math.max(0, Math.min(200, parseFloat(val) || 0));
  }

  function supplementPerM2Cents() {
    return state.catalog?.products?.baseChauxM2?.perM2Cents || 2500;
  }

  function isFinitionCoule() {
    return state.finition === 'coule';
  }

  function couleSupplementTotalCents() {
    const m2 = effectiveM2();
    return Math.max(1, Math.ceil(m2)) * supplementPerM2Cents();
  }

  function prepSupplementTotalCents() {
    return couleSupplementTotalCents();
  }

  function syncPrimaireFromSubstrate() {
    const sub = state.catalog?.substrates?.find((s) => s.id === state.substrate);
    state._primaireType = sub?.primaireType || 'universel';
  }

  function primaireTypeLabel() {
    syncPrimaireFromSubstrate();
    return state._primaireType === 'carrelage' ? 'Primaire carrelage' : 'Primaire universel';
  }

  function finitionLabel() {
    if (state.finition === 'coule') return 'Minérale 2 couches + béton coulé';
    return 'Béton ciré minérale seule';
  }

  function substrateLabel() {
    const sub = state.catalog?.substrates?.find((s) => s.id === state.substrate);
    return sub?.label || '—';
  }

  function pickPrimaireForCart(m2) {
    syncPrimaireFromSubstrate();
    const isCarrelage = state._primaireType === 'carrelage';
    const smallKey = isCarrelage ? 'primaireCarrelage5L' : 'primaireUniversel1L';
    const largeKey = isCarrelage ? 'primaireCarrelage5L' : 'primaireUniversel5L';
    return pickProtectionSize(m2, smallKey, largeKey);
  }

  function sortTeintesForDisplay(teintes) {
    const orderIdx = (t) => {
      const i = TEINTE_CATEGORY_ORDER.indexOf(t.category);
      return i >= 0 ? i : 99;
    };
    return [...teintes].sort((a, b) => {
      if (a.featured && !b.featured) return -1;
      if (!a.featured && b.featured) return 1;
      const ca = orderIdx(a);
      const cb = orderIdx(b);
      if (ca !== cb) return ca - cb;
      return parseInt(a.num, 10) - parseInt(b.num, 10);
    });
  }

  function teintesByCategory() {
    const sorted = sortTeintesForDisplay(state.teintes);
    const featured = sorted.filter((t) => t.featured);
    const groups = [];
    if (featured.length) {
      groups.push({ id: 'featured', label: 'Coups de cœur', lead: 'Nos teintes les plus demandées.', items: featured });
    }
    const cats = state.catalog?.teinteCategories || [];
    cats.forEach((cat) => {
      const items = sorted.filter((t) => t.category === cat.id && !t.featured);
      if (items.length) groups.push({ id: cat.id, label: cat.label, lead: cat.lead, items });
    });
    const other = sorted.filter(
      (t) => !t.featured && !cats.some((c) => c.id === t.category)
    );
    if (other.length) {
      groups.push({ id: 'autres', label: 'Autres teintes', lead: '', items: other });
    }
    return groups;
  }

  function stepGuide(stepKey) {
    return state.catalog?.stepGuides?.[stepKey] || {};
  }

  function formatPerM2(cents) {
    return `${formatMoney(cents)}/m²`;
  }

  function rawM2() {
    return clampM2(state.m2Floor) + clampM2(state.m2Wall);
  }

  function effectiveM2() {
    const base = Math.max(1, rawM2());
    return state.waste ? Math.round(base * 1.1 * 10) / 10 : base;
  }

  function clearAutoAdvanceTimer() {
    if (autoAdvanceTimer) {
      clearTimeout(autoAdvanceTimer);
      autoAdvanceTimer = null;
    }
  }

  /** Avance à l’étape suivante si l’étape courante est valide (parcours par clics). */
  function scheduleAutoAdvance(expectedStep, delay = AUTO_ADVANCE_MS) {
    clearAutoAdvanceTimer();
    autoAdvanceTimer = setTimeout(() => {
      autoAdvanceTimer = null;
      if (state.step !== expectedStep) return;
      if (validateStep()) return;
      if (expectedStep >= STEPS - 1) return;
      showStep(expectedStep + 1);
    }, delay);
  }

  function assetUrl(filename) {
    const config = getConfig();
    const base = config.assetBase || '';
    return filename ? `${base}${filename}` : '';
  }

  function resolveStageImage() {
    const config = getConfig();
    const v = config.visuals || {};
    const teinte = state.teintes.find((t) => t.slug === state.teinte);

    if (teinte?.projection) return assetUrl(teinte.projection);
    if (isFinitionCoule() && v.finitionCoule) return v.finitionCoule;
    if (state.step === 2) {
      return isFinitionCoule()
        ? assetUrl('biocemento-homepage-10.jpg')
        : assetUrl('biocemento-homepage-09.jpg');
    }
    if (state.space?.image) return assetUrl(state.space.image);
    return v.project || v.default;
  }

  function teinteGallery(teinte) {
    const base = getConfig().assetBase || '';
    const v = getConfig().visuals || {};
    const urls = [];
    if (teinte?.projection) urls.push({ src: `${base}${teinte.projection}`, label: 'Projet teinté' });
    if (teinte?.texture) urls.push({ src: `${base}${teinte.texture}`, label: 'Texture' });
    if (Array.isArray(teinte?.gallery)) {
      teinte.gallery.forEach((file, i) => {
        urls.push({ src: `${base}${file}`, label: `Projet ${i + 1}` });
      });
    }
    if (v.project) urls.push({ src: v.project, label: 'Réalisation Biocemento' });
    if (state.space?.image) urls.push({ src: assetUrl(state.space.image), label: state.space.label });
    const seen = new Set();
    const unique = urls.filter((item) => {
      if (!item.src || seen.has(item.src)) return false;
      seen.add(item.src);
      return true;
    });
    while (unique.length < 3 && v.project && !seen.has(v.project)) {
      unique.push({ src: v.project, label: 'Ambiance' });
      seen.add(v.project);
    }
    while (unique.length < 3 && teinte?.projection) {
      const src = `${base}${teinte.projection}`;
      if (!seen.has(src)) {
        unique.push({ src, label: 'Vue projet' });
        seen.add(src);
      } else break;
    }
    return unique;
  }

  function bindDetailGallery(gallery) {
    if (!gallery) return;
    gallery.querySelectorAll('.bio-config__rl-detail-thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('.bio-config__rl-detail-thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function kitComponentGroup(key) {
    if (key.startsWith('minerale')) return 'Minérale';
    if (key.startsWith('primaire')) return 'Primaire';
    if (key === 'baseChaux') return 'Coulé';
    if (key === 'prepRenforcee') return 'Préparation';
    if (key.startsWith('impregnateur')) return 'Protection';
    if (key.startsWith('vernis')) return 'Finition';
    return 'Produit';
  }

  function updateKitTitle() {
    const el = $('[data-bio-config-kit-title]');
    if (!el) return;
    const label = state.space?.label || 'votre projet';
    el.textContent = `Kit béton ciré — ${label}`;
  }

  function renderKitTable() {
    const tbody = $('[data-bio-config-kit-rows]');
    if (!tbody) return;
    updateKitTitle();

    if (!state.space) {
      tbody.innerHTML =
        '<tr class="bio-config__kit-empty"><td colspan="4">Commencez par choisir une zone à droite</td></tr>';
      return;
    }

    const teinte = state.teintes.find((t) => t.slug === state.teinte);
    const { lines } = buildLines({ includeProtection: state.step >= 4 });
    const rows = [];

    rows.push({
      component: 'Projet',
      choices: state.space.label,
      qty: '—',
      cost: '—',
    });

    if (rawM2() >= 1) {
      rows.push({
        component: 'Surface',
        choices: `Sols ${formatM2(clampM2(state.m2Floor))} m² · Murs ${formatM2(clampM2(state.m2Wall))} m²`,
        qty: `${formatM2(effectiveM2())} m²`,
        cost: '—',
      });
    }

    if (teinte && lines.length) {
      lines.forEach((l) => {
        rows.push({
          component: kitComponentGroup(l.key),
          choices: l.label,
          qty: String(l.qty),
          cost: formatMoney(l.priceCents),
        });
      });
    } else {
      if (state.finition) {
        rows.push({
          component: 'Finition',
          choices: finitionLabel(),
          qty: '—',
          cost: isFinitionCoule() ? formatMoney(couleSupplementTotalCents()) : 'Inclus',
        });
      }
      if (state.substrate) {
        rows.push({
          component: 'Support',
          choices: substrateLabel(),
          qty: '—',
          cost: primaireTypeLabel(),
        });
      }
      if (state.prepRenforcee) {
        rows.push({
          component: 'Préparation',
          choices: 'Préparation renforcée Biocemento',
          qty: `${Math.max(1, Math.ceil(effectiveM2()))} m²`,
          cost: formatMoney(prepSupplementTotalCents()),
        });
      }
      if (teinte) {
        rows.push({
          component: 'Teinte',
          choices: `N°${teinte.num} — ${teinte.name}`,
          qty: '—',
          cost: '—',
        });
      }
    }

    tbody.innerHTML = rows
      .map(
        (r) => `
      <tr>
        <td>${r.component}</td>
        <td>${r.choices}</td>
        <td>${r.qty}</td>
        <td>${r.cost}</td>
      </tr>`
      )
      .join('');
  }

  function updateActionBar() {
    const totalEl = $('[data-bio-config-action-total]');
    const nextBtn = $('[data-bio-config-next]');
    const atcBtn = $('[data-bio-config-atc]');
    const teinte = state.teintes.find((t) => t.slug === state.teinte);
    const { totalCents } = buildLines({ includeProtection: state.step >= 4 });

    if (totalEl) {
      totalEl.textContent = teinte && totalCents > 0 ? formatMoney(totalCents) : '—';
    }

    if (nextBtn && atcBtn) {
      const isRecap = state.step === 4;
      nextBtn.hidden = isRecap;
      atcBtn.hidden = !isRecap;
    }
  }

  function fillDetailPanel(panel, { title, price, copy, bullets, images }) {
    if (!panel) return;
    const titleEl = panel.querySelector('[data-bio-config-detail-title], [data-bio-config-detail-title-teinte]');
    const priceEl = panel.querySelector('[data-bio-config-detail-price]');
    const copyEl = panel.querySelector('[data-bio-config-detail-copy], [data-bio-config-detail-copy-teinte]');
    const bulletsEl = panel.querySelector('[data-bio-config-detail-bullets]');
    const gallery = panel.querySelector('[data-bio-config-detail-gallery], [data-bio-config-detail-gallery-teinte]');

    if (titleEl) titleEl.textContent = title || '';
    if (priceEl) {
      if (price) {
        priceEl.hidden = false;
        priceEl.textContent = price;
      } else {
        priceEl.hidden = true;
      }
    }
    if (copyEl) copyEl.textContent = copy || '';
    if (bulletsEl) {
      if (bullets?.length) {
        bulletsEl.hidden = false;
        bulletsEl.innerHTML = bullets.map((b) => `<li>${b}</li>`).join('');
      } else {
        bulletsEl.hidden = true;
      }
    }
    if (gallery) {
      const urls = (images || [])
        .map((img) => (img.startsWith('http') ? img : assetUrl(img)))
        .filter(Boolean);
      gallery.innerHTML = urls
        .map(
          (src, i) =>
            `<button type="button" class="bio-config__rl-detail-thumb${i === 0 ? ' is-active' : ''}" data-src="${src}" style="background-image:url('${src}')"></button>`
        )
        .join('');
      bindDetailGallery(gallery);
    }
    panel.hidden = false;
  }

  function showSystemDetail(detailId) {
    activeSystemDetail = detailId;
    const d = OPTION_DETAILS[detailId];
    const panel = $('[data-bio-config-detail]');
    if (!d || !panel) return;
    fillDetailPanel(panel, {
      title: d.title,
      price: d.price,
      copy: d.copy,
      bullets: d.bullets,
      images: [...d.images, state.space?.image, 'apres.jpg'].filter(Boolean),
    });
  }

  function updateTeinteDetail() {
    const panel = $('[data-bio-config-detail-teinte]');
    const selectedLabel = $('[data-bio-config-teinte-selected]');
    const teinte = state.teintes.find((t) => t.slug === state.teinte);

    if (selectedLabel) {
      selectedLabel.textContent = teinte ? `${teinte.name} ${teinte.num}` : '—';
    }

    if (!panel) return;

    if (!teinte) {
      const guide = stepGuide('teinte');
      fillDetailPanel(panel, {
        title: guide.title || 'Choisissez votre teinte',
        copy:
          guide.copy ||
          'Parcourez les teintes. Cliquez sur une carte pour voir le rendu sur un projet type.',
        bullets: [],
        images: [guide.image, getConfig().visuals?.project].filter(Boolean),
      });
      return;
    }

    fillDetailPanel(panel, {
      title: `${teinte.name} ${teinte.num}`,
      copy: teinte.copy || teinte.tagline || '',
      bullets: [teinte.tagline, teinte.categoryGuide || teinte.categoryLabel].filter(Boolean),
      images: teinteGallery(teinte).map((g) => g.src),
    });
  }

  function updateDetailPanel() {
    if (state.step === 2) {
      showSystemDetail(activeSystemDetail);
      return;
    }
    if (state.step === 3) {
      updateTeinteDetail();
      return;
    }
    const sysPanel = $('[data-bio-config-detail]');
    const teintePanel = $('[data-bio-config-detail-teinte]');
    if (sysPanel) sysPanel.hidden = true;
    if (teintePanel) teintePanel.hidden = true;
  }

  function updateSurfaceContext() {
    const el = $('[data-bio-config-surface-context]');
    if (!el) return;
    el.textContent = state.space
      ? `Projet « ${state.space.label} » — renseignez les superficies sol et murs.`
      : '';
  }

  function resolveStageCopy() {
    const teinte = state.teintes.find((t) => t.slug === state.teinte);
    const m2 = formatM2(effectiveM2());

    if (state.step === 0) {
      return { kicker: 'Configurateur', title: 'Choisissez votre espace', tag: 'Démarrage immédiat' };
    }
    if (state.step === 1) {
      return {
        kicker: state.space?.label || 'Superficies',
        title: `${m2} m² à habiller`,
        tag: `Sols ${formatM2(clampM2(state.m2Floor))} m² · Murs ${formatM2(clampM2(state.m2Wall))} m²`,
      };
    }
    if (state.step === 2) {
      return {
        kicker: 'Système',
        title: finitionLabel(),
        tag: isFinitionCoule() ? `${formatPerM2(supplementPerM2Cents())} · coulé` : 'Minérale incluse',
      };
    }
    if (state.step === 3 && teinte) {
      return {
        kicker: `N°${teinte.num} — ${teinte.name}`,
        title: isFinitionCoule() ? 'Rendu béton coulé' : 'Rendu minéral',
        tag: teinte.tagline || '',
      };
    }
    return { kicker: 'Biocemento®', title: 'Projetez-vous', tag: '21 teintes minérales' };
  }

  function setHeroImage(el, url) {
    if (!el || !url) return;
    const next = url;
    if (el.dataset.currentUrl === next) return;
    el.classList.add('is-changing');
    el.style.backgroundImage = `url('${next}')`;
    el.dataset.currentUrl = next;
    window.setTimeout(() => el.classList.remove('is-changing'), 520);
  }

  function updateVisualStage() {
    const url = resolveStageImage();
    const copy = resolveStageCopy();
    const hero = $('[data-bio-config-hero]');
    const mobileHero = $('[data-bio-config-mobile-hero-img]');
    const mobileWrap = $('[data-bio-config-mobile-hero]');
    const mobileTitle = $('[data-bio-config-mobile-hero-title]');

    setHeroImage(hero, url);
    setHeroImage(mobileHero, url);

    const kicker = $('[data-bio-config-stage-kicker]');
    const title = $('[data-bio-config-stage-title]');
    const tag = $('[data-bio-config-stage-tag]');
    if (kicker) kicker.textContent = copy.kicker;
    if (title) title.textContent = copy.title;
    if (tag) tag.textContent = copy.tag;
    if (mobileTitle) mobileTitle.textContent = copy.title;

    if (mobileWrap) {
      const showMobileHero = state.step >= 1 && state.step <= 4;
      mobileWrap.hidden = !showMobileHero;
      mobileWrap.setAttribute('aria-hidden', showMobileHero ? 'false' : 'true');
    }
  }

  function updateSurfacePanelMode() {
    const panel = $('[data-bio-config-surface-panel]');
    if (!panel) return;
    const id = state.space?.id;
    panel.classList.remove('is-floor-only', 'is-wall-only');
    if (id === 'mur') panel.classList.add('is-wall-only');
    else if (id === 'sol' || id === 'escalier' || id === 'exterieur') panel.classList.add('is-floor-only');
  }

  /**
   * Optimisation kits : privilégier 15 m², 5 m² en complément.
   */
  function optimizePacks(requiredM2) {
    let count15 = Math.floor(requiredM2 / 15);
    let remainder = requiredM2 - count15 * 15;
    let count5 = 0;

    if (!state.hasMinerale5) {
      if (remainder > 0.01 || count15 === 0) count15 = Math.max(1, Math.ceil(requiredM2 / 15));
      return { count15, count5: 0, coverage: count15 * 15 };
    }

    if (remainder <= 0.01) {
      return { count15, count5, coverage: count15 * 15 };
    }

    if (count15 === 0 && remainder >= 10) {
      count15 = 1;
      remainder = 0;
    } else if (remainder >= 10) {
      count15 += 1;
      remainder = 0;
    } else if (remainder > 5) {
      count5 = 2;
    } else {
      count5 = 1;
    }

    const coverage = count15 * 15 + count5 * 5;
    return { count15, count5, coverage };
  }

  function productPrice(key, qty = 1) {
    const def = state.catalog?.products?.[key];
    const handle = def?.handle;
    const product = handle ? state.products[handle] : null;
    const variant = product?.variants?.[0];
    const unit = variant?.price ?? def?.fallbackPriceCents ?? def?.perM2Cents ?? 0;
    return unit * qty;
  }

  function variantPriceCents(variant, fallback) {
    if (!variant?.price) return fallback || 0;
    const p = Number(variant.price);
    return p > 500 ? p : Math.round(p * 100);
  }

  function findVariantByDef(product, def) {
    if (!product?.variants?.length) return null;
    if (def?.variantTitle) {
      const t = def.variantTitle.toLowerCase();
      return (
        product.variants.find((v) => {
          const label = [v.title, v.option1, v.option2].filter(Boolean).join(' ').toLowerCase();
          return label === t || label.includes(t);
        }) || product.variants[0]
      );
    }
    return product.variants[0];
  }

  function findVariantByTeinte(product, teinte) {
    if (!product?.variants || !teinte) return product?.variants?.[0] || null;
    const num = String(teinte.num || '').padStart(2, '0');
    const numShort = String(parseInt(num, 10));
    const patterns = [`n°${num}`, `n°0${numShort}`, `n°${numShort}`, `n° ${num}`, `no${num}`];
    const name = (teinte.name || '').toLowerCase();

    const match =
      product.variants.find((v) => {
        const opts = [v.title, v.option1, v.option2, v.option3].filter(Boolean).join(' ').toLowerCase();
        return patterns.some((p) => opts.includes(p)) || (name && opts.includes(name));
      }) || product.variants[0];
    return match;
  }

  function protectionAvailable(key) {
    const def = state.catalog?.products?.[key];
    if (!def?.handle) return false;
    const pub = state.catalog?.storefrontPublished?.[def.handle];
    if (pub === false) return false;
    if (pub === true && def.variantId) return true;
    return Boolean(state.products[def.handle]?.variants?.length);
  }

  function pickProtectionSize(m2, smallKey, largeKey) {
    const small = state.catalog.products[smallKey];
    const large = state.catalog.products[largeKey];
    const useSmall = m2 <= (small?.coverageM2 || 10) && protectionAvailable(smallKey);
    const key = useSmall ? smallKey : largeKey;
    const def = state.catalog.products[key];
    const cov = def?.coverageM2 || 50;
    const qty = useSmall ? 1 : Math.max(1, Math.ceil(m2 / cov));
    return { key, qty };
  }

  function resolveVariantId(def, product, teinte, packKey) {
    if (def?.variantId) return def.variantId;
    const num = teinte?.num ? String(teinte.num).padStart(2, '0') : null;
    const embedded = num && packKey ? state.catalog?.storefrontVariants?.[packKey]?.[num] : null;
    if (embedded) return embedded;
    const variant = teinte
      ? findVariantByTeinte(product, teinte)
      : findVariantByDef(product, def);
    return variant?.id || null;
  }

  function buildLines(opts = {}) {
    const catalog = state.catalog;
    if (!catalog) return { lines: [], totalCents: 0, safetyNote: '' };

    const includeProtection = opts.includeProtection ?? state.step >= 4;
    const m2 = effectiveM2();
    const packs = optimizePacks(m2);
    const lines = [];
    let total = 0;

    const teinte = state.teintes.find((t) => t.slug === state.teinte);

    if (packs.count15 > 0) {
      const def = catalog.products.minerale15;
      const product = state.products[def.handle];
      const variant = findVariantByTeinte(product, teinte);
      const price = variantPriceCents(variant, def.fallbackPriceCents);
      const variantId = resolveVariantId(def, product, teinte, 'minerale15');
      lines.push({
        key: 'minerale15',
        label: def.label,
        qty: packs.count15,
        coverage: `${def.coverageM2} m² / unité`,
        layers: def.layers,
        priceCents: price * packs.count15,
        variantId,
        handle: def.handle,
      });
      total += price * packs.count15;
    }

    if (packs.count5 > 0) {
      const def = catalog.products.minerale5;
      const product = state.products[def.handle];
      const variant = findVariantByTeinte(product, teinte);
      const price = variantPriceCents(variant, def.fallbackPriceCents);
      const variantId = resolveVariantId(def, product, teinte, 'minerale5');
      lines.push({
        key: 'minerale5',
        label: def.label,
        qty: packs.count5,
        coverage: `${def.coverageM2} m² / unité`,
        layers: def.layers,
        priceCents: price * packs.count5,
        variantId,
        handle: def.handle,
      });
      total += price * packs.count5;
    }

    if (packs.coverage > m2 + 0.01) {
      state._safetyNote =
        'Une marge de sécurité supplémentaire a été intégrée afin de garantir le confort d\'application sur chantier.';
    } else {
      state._safetyNote = '';
    }

    if (isFinitionCoule() && m2 >= 1) {
      const def = catalog.products.baseChauxM2;
      const product = state.products[def.handle];
      const variant = findVariantByDef(product, def);
      const qty = Math.max(1, Math.ceil(m2));
      const unit = variantPriceCents(variant, def.perM2Cents);
      lines.push({
        key: 'baseChaux',
        label: def.label,
        qty,
        coverage: `${formatM2(m2)} m²`,
        layers: def.layers,
        priceCents: unit * qty,
        variantId: resolveVariantId(def, product, null, null),
        handle: def.handle,
        note: formatPerM2(def.perM2Cents || supplementPerM2Cents()),
      });
      total += unit * qty;
    }

    if (state.prepRenforcee && m2 >= 1) {
      const def = catalog.products.prepRenforceeM2;
      const product = state.products[def.handle];
      const variant = findVariantByDef(product, def);
      const qty = Math.max(1, Math.ceil(m2));
      const unit = variantPriceCents(variant, def.perM2Cents);
      lines.push({
        key: 'prepRenforcee',
        label: def.label,
        qty,
        coverage: `${formatM2(m2)} m²`,
        layers: def.layers,
        priceCents: unit * qty,
        variantId: resolveVariantId(def, product, null, null),
        handle: def.handle,
        note: formatPerM2(def.perM2Cents || supplementPerM2Cents()),
      });
      total += unit * qty;
    }

    if (state.substrate && m2 >= 1) {
      const primaire = pickPrimaireForCart(m2);
      const def = catalog.products[primaire.key];
      if (protectionAvailable(primaire.key)) {
        const product = state.products[def.handle];
        const variant = product?.variants?.[0];
        const price = variantPriceCents(variant, def.fallbackPriceCents);
        const variantId = resolveVariantId(def, product, null, null);
        if (variantId) {
          lines.push({
            key: primaire.key,
            label: def.label,
            qty: primaire.qty,
            coverage: `${def.coverageM2} m²`,
            layers: def.layers || '—',
            priceCents: price * primaire.qty,
            variantId,
            handle: def.handle,
          });
          total += price * primaire.qty;
        }
      }
    }

    if (includeProtection && m2 >= 1 && teinte) {
      const imp = pickProtectionSize(m2, 'impregnateur1L', 'impregnateur5L');
      const vernis = pickProtectionSize(m2, 'vernis1L', 'vernis5L');

      [imp, vernis].forEach((pick) => {
        const def = catalog.products[pick.key];
        if (!protectionAvailable(pick.key)) return;
        const product = state.products[def.handle];
        const variant = product?.variants?.[0];
        const price = variantPriceCents(variant, def.fallbackPriceCents);
        const variantId = resolveVariantId(def, product, null, null);
        if (!variantId) return;
        lines.push({
          key: pick.key,
          label: def.label,
          qty: pick.qty,
          coverage: `${def.coverageM2} m²`,
          layers: def.layers || '—',
          priceCents: price * pick.qty,
          variantId,
          handle: def.handle,
        });
        total += price * pick.qty;
      });
    }

    return { lines, totalCents: total, safetyNote: state._safetyNote || '', packs };
  }

  function whatsappMessage() {
    const space = state.space?.label || '—';
    const teinte = state.teintes.find((t) => t.slug === state.teinte);
    return [
      'Bonjour,',
      'je souhaite être accompagné pour mon projet Biocemento.',
      '',
      `Espace : ${space}`,
      `Surface sol : ${formatM2(clampM2(state.m2Floor))} m²`,
      `Surface murs : ${formatM2(clampM2(state.m2Wall))} m²`,
      `Surface totale : ${formatM2(effectiveM2())} m²`,
      `Finition : ${finitionLabel()}`,
      `Support : ${substrateLabel()}`,
      `Préparation renforcée : ${state.prepRenforcee ? 'Oui' : 'Non'}`,
      `Teinte : ${teinte ? teinte.name : '—'}`,
      '',
      'Pouvez-vous me confirmer si mon support est adapté ?',
    ].join('\n');
  }

  function updateWhatsAppLinks() {
    const config = getConfig();
    const base = config.whatsappUrl?.split('?')[0] || 'https://wa.me/33651558093';
    const url = `${base}?text=${encodeURIComponent(whatsappMessage())}`;
    $$('[data-bio-config-wa-sticky], [data-bio-config-wa-recap]').forEach((a) => {
      a.href = url;
    });
  }

  function renderRelentlessPickerCards(container, items, selectedId, onSelect) {
    if (!container) return;
    const base = getConfig().assetBase || '';
    container.innerHTML = items
      .map((item) => {
        const img = item.image ? `${base}${item.image}` : '';
        return `
      <button type="button" class="bio-config__rl-zone-card${selectedId === item.id ? ' is-selected' : ''}"
        data-id="${item.id}" aria-pressed="${selectedId === item.id}">
        <span class="bio-config__rl-zone-head">${item.label}</span>
        <span class="bio-config__rl-zone-media" style="background-image:url('${img}')"></span>
        <span class="bio-config__rl-zone-foot">Choisir</span>
      </button>`;
      })
      .join('');

    container.querySelectorAll('.bio-config__rl-zone-card').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = items.find((x) => x.id === btn.dataset.id);
        if (item) onSelect(item);
        container.querySelectorAll('.bio-config__rl-zone-card').forEach((b) => {
          const on = b.dataset.id === btn.dataset.id;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on);
        });
        renderKitTable();
        updateKitTitle();
        updateActionBar();
      });
    });
  }

  function renderCards(container, items, selectedId, onSelect) {
    if (!container) return;
    if (
      container.classList.contains('bio-config__cards--relentless') ||
      container.classList.contains('bio-config__rl-cards')
    ) {
      renderRelentlessPickerCards(container, items, selectedId, onSelect);
      return;
    }
    const base = getConfig().assetBase || '';
    const isSubstrate = container.classList.contains('bio-config__cards--substrate');
    container.innerHTML = items
      .map((item) => {
        const img = item.image ? `${base}${item.image}` : '';
        const media = img
          ? `<span class="bio-config__card-media" style="background-image:url('${img}')"></span><span class="bio-config__card-shade"></span>`
          : '';
        return `
      <button type="button" class="bio-config__card${selectedId === item.id ? ' is-selected' : ''}${isSubstrate ? ' bio-config__card--substrate' : ''}"
        data-id="${item.id}" data-image="${img}" aria-pressed="${selectedId === item.id}">
        ${media}
        <span class="bio-config__card-label">${item.label}</span>
        <span class="bio-config__card-check" aria-hidden="true"></span>
      </button>`;
      })
      .join('');

    container.querySelectorAll('.bio-config__card').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = items.find((x) => x.id === btn.dataset.id);
        if (item) onSelect(item);
        container.querySelectorAll('.bio-config__card').forEach((b) => {
          const on = b.dataset.id === btn.dataset.id;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on);
        });
        updateUI();
        scheduleAutoAdvance(state.step);
      });
    });
  }

  function filteredTeintes() {
    const q = teinteSearchQuery.trim().toLowerCase();
    const sorted = sortTeintesForDisplay(state.teintes);
    if (!q) return sorted;
    return sorted.filter(
      (t) =>
        t.name.toLowerCase().includes(q) ||
        String(t.num).includes(q) ||
        (t.slug && t.slug.includes(q))
    );
  }

  function renderTeinteSwatch(t, base) {
    const proj = t.projection ? `${base}${t.projection}` : '';
    return `
      <button type="button" class="bio-config__rl-swatch${state.teinte === t.slug ? ' is-selected' : ''}"
        data-slug="${t.slug}" aria-pressed="${state.teinte === t.slug}">
        <span class="bio-config__rl-swatch-media" style="background-image:url('${proj}')"></span>
        <span class="bio-config__rl-swatch-label">${t.name}<br>${t.num}</span>
      </button>`;
  }

  function renderTeintes() {
    const el = $('[data-bio-config-teintes]');
    if (!el) return;
    const base = getConfig().assetBase || '';
    const list = filteredTeintes();
    el.innerHTML = list.map((t) => renderTeinteSwatch(t, base)).join('');

    el.querySelectorAll('.bio-config__rl-swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.teinte = btn.dataset.slug;
        try {
          localStorage.setItem(STORAGE_TEINTE, state.teinte);
        } catch (e) {
          /* ignore */
        }
        el.querySelectorAll('.bio-config__rl-swatch').forEach((b) => {
          const on = b.dataset.slug === state.teinte;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on);
        });
        updateTeinteDetail();
        renderKitTable();
        updateActionBar();
      });
    });
    updateTeinteDetail();
  }

  function renderRecap() {
    const safety = $('[data-bio-config-safety-note]');
    const { safetyNote } = buildLines();

    if (safety) {
      safety.hidden = !safetyNote;
      safety.textContent = safetyNote;
    }

    renderKitTable();
    updateActionBar();
    updateWhatsAppLinks();
  }

  function updateSurfaceDisplay() {
    const calc = $('[data-bio-config-m2-calc]');
    const breakdown = $('[data-bio-config-m2-breakdown]');
    const floorIn = $('[data-bio-config-m2-floor]');
    const wallIn = $('[data-bio-config-m2-wall]');

    if (floorIn) floorIn.value = clampM2(state.m2Floor);
    if (wallIn) wallIn.value = clampM2(state.m2Wall);
    if (calc) calc.textContent = `${formatM2(effectiveM2())} m²`;

    if (breakdown) {
      const floor = clampM2(state.m2Floor);
      const wall = clampM2(state.m2Wall);
      const raw = rawM2();
      const total = effectiveM2();
      const wasteRow =
        state.waste && raw >= 1
          ? `<div><dt>Marge 10&nbsp;% (pertes / découpes)</dt><dd>+${formatM2(total - raw)} m²</dd></div>`
          : '';
      breakdown.innerHTML = `
        <dl>
          <div><dt>Superficie sol</dt><dd>${formatM2(floor)} m²</dd></div>
          <div><dt>Superficie murs</dt><dd>${formatM2(wall)} m²</dd></div>
          <div><dt>Sous-total</dt><dd>${formatM2(raw)} m²</dd></div>
          ${wasteRow}
        </dl>`;
    }

    updateSurfacePanelMode();
  }

  function updateCompatCard() {
    const card = $('[data-bio-config-compat]');
    if (!card) return;
    card.classList.remove('is-warn');
    card.querySelector('.bio-config__status-title').textContent = 'Projet compatible';
    card.querySelector('.bio-config__status-text').textContent =
      'Votre configuration peut être finalisée en ligne.';
    card.querySelector('.bio-config__status-icon').textContent = '✓';
  }

  function renderSubstrateOptions() {
    const el = $('[data-bio-config-substrate]');
    const items = state.catalog?.substrates || [];
    if (!el || !items.length) return;
    const base = getConfig().assetBase || '';
    el.innerHTML = items
      .map((item) => {
        const img = item.image ? `${base}${item.image}` : '';
        const selected = state.substrate === item.id;
        return `
      <button type="button" class="bio-config__rl-option${selected ? ' is-selected' : ''}"
        data-substrate="${item.id}" data-detail-id="substrate-${item.id}" aria-pressed="${selected}">
        <span class="bio-config__rl-option-badge bio-config__rl-option-badge--${item.id === 'carrelage' ? 'pro' : 'diy'}">${item.label}</span>
        <span class="bio-config__rl-option-media" style="background-image:url('${img}')"></span>
        <span class="bio-config__rl-option-foot">
          <strong>${item.label}</strong>
          <span>${item.primaireType === 'carrelage' ? 'Primaire carrelage' : 'Universel'}</span>
        </span>
      </button>`;
      })
      .join('');

    el.querySelectorAll('[data-substrate]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.substrate = btn.dataset.substrate;
        if (state.substrate !== 'planeite') state.prepRenforcee = false;
        el.querySelectorAll('[data-substrate]').forEach((b) => {
          const on = b.dataset.substrate === state.substrate;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on);
        });
        updateSystemUI();
        showSystemDetail(`substrate-${state.substrate}`);
        renderRecap();
      });
    });
  }

  function updateSystemUI() {
    const perM2 = supplementPerM2Cents();
    const priceCoule = $('[data-bio-config-finition-price-coule]');
    const pricePrep = $('[data-bio-config-prep-m2-price]');
    if (priceCoule) priceCoule.textContent = `+ ${formatPerM2(perM2)}`;
    if (pricePrep) pricePrep.textContent = `+ ${formatPerM2(perM2)}`;

    $$('[data-bio-config-finition] [data-finition]').forEach((btn) => {
      const on = btn.dataset.finition === state.finition;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on);
    });

    const supportPanel = $('[data-bio-config-support-panel]');
    if (supportPanel) supportPanel.hidden = !state.finition;

    const prepPanel = $('[data-bio-config-prep-panel]');
    if (prepPanel) prepPanel.hidden = state.substrate !== 'planeite';

    const prepBtn = $('[data-bio-config-prep-renforcee]');
    if (prepBtn) {
      prepBtn.classList.toggle('is-on', state.prepRenforcee);
      prepBtn.setAttribute('aria-pressed', state.prepRenforcee ? 'true' : 'false');
    }

    const finitionNote = $('[data-bio-config-finition-note]');
    if (finitionNote) {
      if (isFinitionCoule()) {
        finitionNote.hidden = false;
        finitionNote.textContent = `Supplément béton coulé : ${formatPerM2(perM2)} × ${formatM2(effectiveM2())} m² = ${formatMoney(couleSupplementTotalCents())} (estimation)`;
      } else {
        finitionNote.hidden = true;
        finitionNote.textContent = '';
      }
    }

    const prepNote = $('[data-bio-config-prep-note]');
    if (prepNote) {
      if (state.prepRenforcee) {
        prepNote.hidden = false;
        prepNote.textContent = `Préparation renforcée : ${formatPerM2(perM2)} × ${formatM2(effectiveM2())} m² = ${formatMoney(prepSupplementTotalCents())} (estimation)`;
      } else {
        prepNote.hidden = true;
        prepNote.textContent = '';
      }
    }

    const teinteLead = $('[data-bio-config-teinte-lead]');
    if (teinteLead) {
      teinteLead.textContent = isFinitionCoule()
        ? `Système coulé · ${formatPerM2(perM2)}. Cliquez sur une teinte pour voir au moins 3 vues projet.`
        : 'Finition minérale. Cliquez sur une teinte pour voir le rendu sur projet.';
    }
  }

  function roadmapStep() {
    return Math.min(state.step, 4);
  }

  function isStepComplete(step) {
    if (step === 0) return Boolean(state.space);
    if (step === 1) return rawM2() >= 1;
    if (step === 2) return Boolean(state.finition && state.substrate);
    if (step === 3) return Boolean(state.teinte);
    if (step === 4) {
      return isStepComplete(0) && isStepComplete(1) && isStepComplete(2) && isStepComplete(3);
    }
    return false;
  }

  function validateStepAt(step) {
    if (step === 0 && !state.space) return 'Choisissez un espace.';
    if (step === 1 && rawM2() < 1) return 'Indiquez au moins 1 m² au sol ou aux murs.';
    if (step === 2 && !state.finition) return 'Choisissez une finition.';
    if (step === 2 && !state.substrate) return 'Indiquez votre type de support.';
    if (step === 3 && !state.teinte) return 'Choisissez une teinte.';
    return null;
  }

  function canNavigateTo(n) {
    if (n < 0 || n >= STEPS || n === state.step) return false;
    for (let i = 0; i < n; i++) {
      if (!isStepComplete(i)) return false;
    }
    return true;
  }

  function firstBlockedMessage(target) {
    for (let i = 0; i < target; i++) {
      const err = validateStepAt(i);
      if (err) return err;
    }
    return null;
  }

  function navigateToStep(n) {
    if (n === state.step) return;
    if (!canNavigateTo(n)) {
      const status = $('[data-bio-config-status]');
      const err = firstBlockedMessage(n);
      if (status && err) {
        status.hidden = false;
        status.textContent = err;
      }
      return;
    }
    const status = $('[data-bio-config-status]');
    if (status) status.hidden = true;
    showStep(n);
  }

  function updateTabs() {
    $$('[data-bio-config-tab], .bio-config__rl-tab').forEach((tab) => {
      const n = parseInt(tab.dataset.bioConfigTab, 10);
      const active = n === state.step;
      const done = n < state.step && isStepComplete(n);
      const reachable = canNavigateTo(n) || active;
      tab.classList.toggle('is-active', active);
      tab.classList.toggle('is-done', done);
      tab.classList.toggle('is-locked', !reachable);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      tab.disabled = !reachable;
    });
  }

  function updateCycleTrack() {
    const fill = $('[data-bio-config-cycle-fill]');
    if (!fill) return;
    const pct = ((state.step + 1) / STEPS) * 100;
    fill.style.width = `${pct}%`;
  }

  function updateRoadmap() {
    const active = roadmapStep();
    $$('[data-bio-config-roadmap] li, [data-bio-config-roadmap-rail] li').forEach((li) => {
      const n = parseInt(li.dataset.roadmap, 10);
      li.classList.remove('is-active', 'is-done');
      if (n < active) li.classList.add('is-done');
      if (n === active) li.classList.add('is-active');
    });
  }

  function updateStepCounter() {
    const el = $('[data-bio-config-step-counter]');
    if (!el) return;
    if (state.step >= 0 && state.step < CONFIG_STEPS) {
      el.hidden = false;
      el.textContent = `Étape ${state.step + 1} / ${CONFIG_STEPS}`;
    } else {
      el.hidden = true;
    }
  }

  function updateMobileCompat() {
    const bar = $('[data-bio-config-mobile-compat]');
    const text = $('[data-bio-config-mobile-compat-text]');
    if (!bar || !text) return;
    if (state.step <= 0) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    text.textContent = 'Projet compatible';
  }

  function updateCompatRecap() {
    const el = $('[data-bio-config-compat-recap]');
    if (!el) return;
    el.textContent = 'Votre projet est compatible et peut être commandé en ligne.';
  }

  function showStep(n) {
    clearAutoAdvanceTimer();
    state.step = Math.max(0, Math.min(STEPS - 1, n));

    $$('[data-bio-config-step]').forEach((section) => {
      const step = parseInt(section.dataset.bioConfigStep, 10);
      const active = step === state.step;
      section.classList.toggle('is-active', active);
      section.hidden = !active;
    });

    if (state.step === 2) {
      renderSubstrateOptions();
      activeSystemDetail = state.substrate
        ? `substrate-${state.substrate}`
        : state.finition === 'coule'
          ? 'finition-coule'
          : 'finition-minerale';
      showSystemDetail(activeSystemDetail);
    }

    if (state.step === 3) renderTeintes();
    renderRecap();

    updateTabs();
    updateSystemUI();
    updateSurfaceDisplay();
    updateSurfaceContext();
    updateCompatRecap();
    updateDetailPanel();
    updateActionBar();
  }

  function validateStep() {
    return validateStepAt(state.step);
  }

  function cartRoot() {
    const config = getConfig();
    return (window.Shopify?.routes?.root || config.routes?.root || '/').replace(/\/?$/, '/');
  }

  async function addToCart() {
    const status = $('[data-bio-config-status]');
    const atc = $('[data-bio-config-atc]');
    const { lines } = buildLines({ includeProtection: true });

    const cartLines = lines.filter((l) => l.variantId);
    if (!cartLines.length) {
      if (status) {
        status.hidden = false;
        status.textContent =
          'Impossible de composer le panier. Rechargez la page ou contactez-nous sur WhatsApp.';
      }
      return;
    }

    const teinte = state.teintes.find((t) => t.slug === state.teinte);
    const props = {
      Configurateur: 'Biocemento',
      Espace: state.space?.label || '',
      'Surface sol': `${formatM2(clampM2(state.m2Floor))} m²`,
      'Surface murs': `${formatM2(clampM2(state.m2Wall))} m²`,
      'Surface totale': `${formatM2(effectiveM2())} m²`,
      Finition: finitionLabel(),
      Support: substrateLabel(),
      'Préparation renforcée': state.prepRenforcee ? 'Oui' : 'Non',
      Teinte: teinte ? `${teinte.num} ${teinte.name}` : '',
    };

    atc?.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const root = cartRoot();
      const items = cartLines.map((line, i) => ({
        id: line.variantId,
        quantity: line.qty,
        properties: i === 0 ? props : undefined,
      }));

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      const json = await res.json();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      if (!res.ok) {
        throw new Error(json.description || json.message || 'Erreur panier');
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      const onSuccessDo = 'force_open_drawer';

      document.documentElement.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: json.items || items, cart, onSuccessDo },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo, cart },
        })
      );
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (status) {
        status.hidden = false;
        status.style.color = '';
        status.textContent = 'Projet ajouté au panier.';
      }
    } catch (err) {
      if (status) {
        status.hidden = false;
        status.textContent = err.message;
      }
    } finally {
      atc?.removeAttribute('aria-busy');
    }
  }

  function bindEvents() {
    const root = getRoot();
    if (!root) return;

    renderCards($('[data-bio-config-space]'), state.catalog?.spaces || [], state.space?.id, (item) => {
      state.space = item;
      updateSurfacePanelMode();
      updateSurfaceContext();
    });

    const m2Floor = $('[data-bio-config-m2-floor]');
    const m2Wall = $('[data-bio-config-m2-wall]');
    const waste = $('[data-bio-config-waste]');

    function syncSurfaces() {
      if (m2Floor) state.m2Floor = clampM2(m2Floor.value);
      if (m2Wall) state.m2Wall = clampM2(m2Wall.value);
      updateSurfaceDisplay();
      updateSystemUI();
      renderRecap();
      updateTabs();
    }

    m2Floor?.addEventListener('input', syncSurfaces);
    m2Wall?.addEventListener('input', syncSurfaces);
    waste?.addEventListener('change', () => {
      state.waste = waste.checked;
      updateSurfaceDisplay();
      renderRecap();
    });

    $$('[data-bio-config-finition] [data-finition]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.finition = btn.dataset.finition;
        if (!state.substrate) state.prepRenforcee = false;
        updateSystemUI();
        showSystemDetail(btn.dataset.detailId || 'finition-minerale');
        renderRecap();
      });
    });

    $('[data-bio-config-prep-renforcee]')?.addEventListener('click', () => {
      state.prepRenforcee = !state.prepRenforcee;
      updateSystemUI();
      showSystemDetail('prep-renforcee');
      renderRecap();
    });

    $$('[data-bio-config-detail-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('[data-bio-config-detail], [data-bio-config-detail-teinte]');
        if (panel) panel.hidden = true;
      });
    });

    $('[data-bio-config-teinte-search]')?.addEventListener('input', (e) => {
      teinteSearchQuery = e.target.value;
      renderTeintes();
    });

    $('[data-bio-config-start-over]')?.addEventListener('click', () => {
      state.space = null;
      state.m2Floor = 8;
      state.m2Wall = 4;
      state.waste = true;
      state.finition = 'minerale';
      state.substrate = null;
      state.prepRenforcee = false;
      state.teinte = state.teintes.find((t) => t.featured)?.slug || state.teintes[0]?.slug;
      if (m2Floor) m2Floor.value = 8;
      if (m2Wall) m2Wall.value = 4;
      if (waste) waste.checked = true;
      renderCards($('[data-bio-config-space]'), state.catalog?.spaces || [], null, (item) => {
        state.space = item;
        updateSurfacePanelMode();
        updateSurfaceContext();
      });
      showStep(0);
      updateUI();
    });

    root.querySelectorAll('[data-bio-config-next]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const err = validateStep();
        const status = $('[data-bio-config-status]');
        if (err) {
          if (status) {
            status.hidden = false;
            status.textContent = err;
          }
          return;
        }
        if (status) status.hidden = true;
        if (state.step < STEPS - 1) showStep(state.step + 1);
      });
    });

    $('[data-bio-config-back]')?.addEventListener('click', () => {
      if (state.step > 0) showStep(state.step - 1);
    });

    $('[data-bio-config-atc]')?.addEventListener('click', addToCart);

    $$('[data-bio-config-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const n = parseInt(tab.dataset.bioConfigTab, 10);
        if (!Number.isNaN(n)) navigateToStep(n);
      });
    });
  }

  function updateUI() {
    updateCompatRecap();
    updateSurfaceContext();
    updateDetailPanel();
    updateTabs();
    renderRecap();
    updateWhatsAppLinks();
    updateActionBar();
  }

  async function init() {
    if (!getRoot()) return;
    await loadData();

    const saved = (() => {
      try {
        return localStorage.getItem(STORAGE_TEINTE);
      } catch (e) {
        return null;
      }
    })();
    const urlTeinte = new URLSearchParams(location.search).get('teinte');
    state.teinte = urlTeinte || saved || state.teintes.find((t) => t.featured)?.slug || state.teintes[0]?.slug;

    bindEvents();
    renderSubstrateOptions();
    updateSystemUI();
    renderKitTable();
    showStep(0);
    updateUI();

    window.BiocementoConfigurator = {
      getState: () => ({ ...state }),
      buildLines,
      showStep,
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
